import { useQuery } from '@tanstack/react-query'
import { masterApiService } from 'api/config'
import { Area } from 'types/area'

export const AREAS_QUERY_KEY = 'areas'
export const AREA_BY_SLUG_QUERY_KEY = 'area-by-slug'

export const fetchAreas = () =>
  masterApiService.getList<Area>('areas/tree', {
    filteredOut: true,
  })

export const fetchAreaBySlug = (slug: string) => masterApiService.getItem<Area>('areas/by-slug', slug)

export const useGetAreaBySlug = (slug: string | undefined) => {
  const { data, ...result } = useQuery({
    queryKey: [AREA_BY_SLUG_QUERY_KEY, slug],
    queryFn: () => fetchAreaBySlug(slug as string),
    enabled: !!slug,
  })

  return {
    ...result,
    area: data,
  }
}

export const useGetAreas = () => {
  const { data, ...result } = useQuery({
    queryKey: [AREAS_QUERY_KEY],
    queryFn: fetchAreas,
    enabled: true,
  })

  return {
    ...result,
    data: data || [],
  }
}
